<p-dialog [(visible)]="displaySearchDialog" [modal]="true" [style]="{width: '65vw', minWidth: '450px'}" (onHide)="hideSearch()">
  <ng-template pTemplate="header">
    <div class="w-full text-center font-20">
      Select Loan Note
    </div>
  </ng-template>
  <div class="formgrid">
    <div class="flex justify-content-between">
      <div class="formgrid grid w-70">
        <div class="mt-3 w-100">
          <div class="row">
            <div class="col">
              <div class="accounts font-13">
                <app-loan-note-node
                  [loanNotes]="loanNotes"
                  [selectedLoanNotes]="selectedLoanNotes"
                  (onAddLoanNote)="onSelect($event)"
                  (onDeleteLoanNote)="deleteSelectedLoanNote($event)">
                </app-loan-note-node>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="w-30 ml-5 mt-20">
        <div class="account-wrapper">
          @for (item of selectedLoanNotes; track item; let i = $index) {
            <div class="account-group-act">
              <div class="account-info">
                <div class="account-info1">
                  <span>{{item.name}}</span>
                </div>
              </div>
              @if (!item.mandatory) {
                <div class="account-action">
                  <em class="pi pi-times delete-icon" style="cursor: pointer;"
                  (click)="deleteSelectedLoanNote(item)"></em>
                </div>
              }
            </div>
          }
        </div>
        <div class="formgrid grid justify-content-center">
          <app-button id="add-note" buttonClass="btn-primary"
            buttonType="button" (clickEvent)="onSave()">
            <span translate>buttons.ok</span>
          </app-button>
          <app-button id="cancel-note" buttonClass="btn-secondary mr-0"
            buttonType="button" (clickEvent)="hideSearch()">
            <span translate>buttons.cancel</span>
          </app-button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>